import {ICollectionMapper} from '../Firestore/ICollectionMapper'
import {IPriceList, PriceList} from './PriceList'
import {PriceListEntryMapper} from './PriceListEntry/PriceListEntryMapper'
import moment from "moment";

export class PriceListMapper implements ICollectionMapper<PriceList> {
  map(data: IPriceList): PriceList {
    const priceList = new PriceList(data.vendorCompanyId, data.restaurantCompanyId)
    priceList.id = data.id
    priceList.vendorRepEmail = data.vendorRepEmail
    priceList.vendorRepPhoneNumber = data.vendorRepPhoneNumber
    priceList.vendorRepName = data.vendorRepName
    priceList.vendorCompanyName = data.vendorCompanyName
    priceList.vendorRepId = data.vendorRepId
    priceList.active = data.active

    priceList.cutoffTime = data.cutoffTime ? moment(data.cutoffTime).toDate() : undefined

    priceList.entries = data.entries.map(( new PriceListEntryMapper ).map)

    return priceList
  }

  serialize(object: PriceList): IPriceList {
    return JSON.parse(JSON.stringify(object))
  }
}
